import { put, takeLatest } from "redux-saga/effects";

import {
  fetchBankApproveListRequest,
  fetchBankApproveListFailure,
  fetchBankApproveListSuccess,
  BankApproveUpdateRequest,
  BankApproveUpdateSuccess ,
  BankApproveUpdateFaliure ,
} from "redux/reducers/acclgl/bank-approve";
import { requestBankApproveList,requestUpdateBankApprove } from "services/acclgl/bank-approve";
export function* watchbankApprove() {
  yield takeLatest(fetchBankApproveListRequest, fetchbankapprovelist);
  yield takeLatest(BankApproveUpdateRequest, updatebankapprovelist);
}

function* fetchbankapprovelist({ payload }) {
  try {
    const response = yield requestBankApproveList(payload);
    yield put(fetchBankApproveListSuccess(response));
  } catch (error) {
    yield put(fetchBankApproveListFailure("Failed to get Bank Approve list"));
  }
}

function* updatebankapprovelist({ payload }) {
    try {
      const response =yield requestUpdateBankApprove(payload);
      yield put(BankApproveUpdateSuccess (response.data));
    } catch (error) {
      yield put(BankApproveUpdateFaliure ('Failed to get update Bank Approve'));
    }
  }
